// extracted by mini-css-extract-plugin
export default {"head":"NewsItemContentHead_head__bvb0U","title":"NewsItemContentHead_title__W3HfW","date":"NewsItemContentHead_date__M01gq","video":"NewsItemContentHead_video__3BBsd"};